// React
import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';

class DialogLogs extends React.PureComponent {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        close: PropTypes.func,
        fullScreen: PropTypes.bool,
        open: PropTypes.bool,
        logs: PropTypes.array
    };

    handleChangeUrl = event => {
        this.setState({ url: event.target.value });
    };

    render() {
        const { fullScreen, classes, logs, open, close } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={close}
                disableRestoreFocus={true}
                aria-labelledby='responsive-dialog-title'
            >
                <DialogTitle id='responsive-dialog-title'>Logs</DialogTitle>
                <DialogContent>
                    {logs.map((log, key) =>
                        <div key={key}>
                            <p className={classes.separator}>{'--------------------------------------------------'}</p>
                            <p className={classes.text}>{'Result : ' + log.type}</p>
                            <p className={classes.text} style={{ whiteSpace: 'pre-line' }}>{log.msg ? 'Message: ' + log.msg : 'Message: No message'}</p>
                            <p className={classes.text}>{'Date : ' + log.date}</p>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <IconButton color='primary' onClick={() => {
                        close();
                    }}>
                        <DoneIcon />
                    </IconButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = () => ({
    separator: {
        marginTop: '0'
    },
    text: {
        fontFamily: 'roboto'
    }
});

export default withStyles(styles)(DialogLogs);
